<template>
    <div id="app">
        <the-header></the-header>
        <router-view/>
    </div>
</template>

<script>
  import TheHeader from './components/TheHeader'

  export default {
    name: 'app',
    components: { TheHeader },

    computed: {
    }
  }
</script>

<style lang="scss">
    @import "assets/_custom.scss";
    @import "~bootstrap/scss/bootstrap.scss";
    @import '~bootstrap-vue/dist/bootstrap-vue.css';

    body {
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        font-size: 14px;
        line-height: 1.42857143;
        color: #333;
        background-color: #fff;
        margin-bottom: 30px;
    }

    .navbar-default {
        background-color: #f8f8f8;
        border-color: #e7e7e7
    }

    .navbar-default .navbar-brand {
        color: #777
    }

    .navbar-default .navbar-brand:hover, .navbar-default .navbar-brand:focus {
        color: #5e5e5e;
        background-color: transparent
    }

    .navbar-default .navbar-text {
        color: #777
    }

    .navbar-default .navbar-nav > li > a {
        color: #777
    }

    .navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {
        color: #333;
        background-color: transparent
    }

    .navbar-default .navbar-nav > .active > a, .navbar-default .navbar-nav > .active > a:hover,
    .navbar-default .navbar-nav > .active > a:focus {
        color: #555;
        background-color: #e7e7e7
    }

    .navbar-default .navbar-nav > .disabled > a, .navbar-default .navbar-nav > .disabled > a:hover,
    .navbar-default .navbar-nav > .disabled > a:focus {
        color: #ccc;
        background-color: transparent
    }

    .navbar-default .navbar-toggle {
        border-color: #ddd
    }

    .navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:focus {
        background-color: #ddd
    }

    .navbar-default .navbar-toggle .icon-bar {
        background-color: #888
    }

    .navbar-default .navbar-collapse, .navbar-default .navbar-form {
        border-color: #e7e7e7
    }

    .navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:hover,
    .navbar-default .navbar-nav > .open > a:focus {
        background-color: #e7e7e7;
        color: #555
    }

    .header div h1 {
        color: rgb(255, 70, 0);
        font-weight: lighter;
        font-size: 28px;
        margin: 0;
    }

    .header > h5 {
        margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
    }

    .patient-search-border {
        /* background: white; */
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
    }

    .search-border {
        /* background: white; */
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        margin: auto;
        margin-left: 10%;
        padding: 0;
    }

    .patient-search {
        border: none;
        border-radius: 4px 0 0 4px;
        box-shadow: none;
        padding-right: 0px;
        min-width: 230px;
    }

    .patient-search:focus {
        box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075),
        inset 0 0 1px rgba(255, 70, 0, .6);
    }

    .patient-search-submit {
        border: none;
        background: white;
        border-radius: 0 4px 4px 0;
    }

    .patient-search-submit:focus,
    .patient-search-submit:focus:active,
    .patient-search-submit:active {
        outline: 5px auto rgba(255, 70, 0, 0.1);
    }

    .patient-search-submit:hover {
        color: rgb(255, 70, 0);
    }

    .headshot {
        height: 125px;
        width: 125px;
        border-radius: 50%;
        border: #FFA800 1px solid;
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        vertical-align: top;
        margin: 0;
        padding: 0;
        top: 0;
        right: 0;
        image-orientation: none;
    }

    .field-label {
        color: #737284;
    }

    .btn.btn-outline-orange {
        color: rgb(0, 0, 0);
    }

    .btn-outline-orange:hover, .btn.btn-outline-orange.orange-text:hover {
        color: #fff;
    }

    .btn-outline-orange:disabled:hover {
        color: #333333;
    }

    .btn-outline-orange:disabled {
      border-color: #333333;
      cursor: not-allowed;
    }

    .large-button {
        background: rgb(255, 213, 84);
        border: 0.5px solid rgb(255, 70, 0);
        color: rgb(255, 70, 0);
    }

    .large-button:focus,
    .large-button:focus:active,
    .large-button:active,
    .large-button:visited {
        background: rgba(255, 213, 84, 0.5);
        border: 0.5px solid rgba(255, 70, 0, 0.5);
        color: rgba(255, 70, 0, 0.5);
        outline: 5px auto rgba(255, 70, 0, 0.1);
    }

    .large-button:hover {
        background: rgba(255, 213, 84, 0.5);
        border: 0.5px solid rgba(255, 70, 0, 0.5);
        color: rgba(255, 70, 0, 0.5);
    }

    /* These have to be non-scoped to adjust bootstrap styling */
    div.vdp-datepicker div input[type="text"] {
        border: 0;
    }

    div.vdp-datepicker div input[type="text"]:FOCUS {
        outline: 0;
    }

    .status-popover .col-form-label {
        font-size: 1rem;
        line-height: 1.5;
    }

    .status-popover legend {
        font-size: 1rem;
        line-height: 1.5;
    }

    .orange-border {
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
    }

    div.form-control.orange-border {
        border: 1px solid rgb(255, 70, 0);
        border-radius: 5px;
    }

    @keyframes spin {
        from { transform: scale(1) rotate(0deg); }
        to { transform: scale(1) rotate(360deg); }
    }

    @-webkit-keyframes spin2 {
        from { -webkit-transform: rotate(0deg); }
        to { -webkit-transform: rotate(360deg); }
    }

    .spinner {
        color: transparent !important;
        pointer-events: none;
        width: 3rem;
        height: 3rem;
        font-size: 3rem;
        display: none;
    }

    .btn.spinning .spinner {
        display: inline-block;
        animation: spin 1s infinite linear;
        -webkit-animation: spin2 1s infinite linear;
    }

    .spinner:after {
        -webkit-animation: spinAround 500ms infinite linear;
        animation: spinAround 500ms infinite linear;
        border: 4px solid white;
        border-radius: 290486px;
        border-right-color: transparent;
        border-top-color: transparent;
        content: "";
        display: block;
        height: 1em;
        position: relative;
        width: 1em;
        position: absolute;
        left: calc(50% - (1em / 2));
        top: calc(50% - (1em / 2));
        position: absolute !important;
    }

    .badge-pill.thin {
        font-weight: 400;
        min-width: 90px;
    }

    .orange {
        color: rgb(255, 70, 0);
    }

    button:HOVER svg.orange {
        color: white;
    }

    .btn-outline-orange:disabled:hover svg.orange {
        color: #333333;
    }

    .btn-outline-orange:disabled svg.orange {
        color: #333333;
    }

    .data-table-header div {
      padding: 0.75rem;
      vertical-align: bottom;
      border-top: 1px solid #dee2e6;
      border-bottom: 2px solid #dee2e6;
      font-weight: bold;
      border-collapse: collapse;
    }

    .data-table-row .column {
      padding: 0.75rem;
      vertical-align: bottom;
      border-collapse: collapse;
    }

    .data-table-row {
      border-bottom: 1px solid #dee2e6;
      background-color: #f9f9f9;
    }

</style>
